import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { ThemeService } from 'src/app/services/theme.service';

export interface DialogDataReason {
  title: string;
  reason: string;
  // QLOD-95: al quitar una instrumentacion critica de protocolo, ademas de la razon se elige
  // en que apartado del informe sale la frase de baja. El que abre el dialogo lee los dos
  // valores de este mismo objeto al cerrarse.
  showChecks?: boolean;
  showDiffInDeviations?: boolean;
  showDiffInObservations?: boolean;
}

@Component({
    selector: 'app-reason-dialog',
    templateUrl: './reason-dialog.component.html',
    standalone: false,
})
export class ReasonDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<ReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataReason,
    private themeService: ThemeService,
    private translate: TranslateService,
    public snackBarService: SnackBarService) {
    if (data.title == null) {
      data.title = 'common.reasonChange';
    }
  }

  onOkClick(): void {
    const errs = [];

    // QLOD-95 (Carlos, 19-oct-2026): un motivo de solo espacios no es un motivo.
    const reason = (this.data.reason ?? '').trim();
    if (reason === '') {
      errs.push(this.translate.instant('common.reasonChangeError'));
    }

    if (errs.length === 0) {
      this.data.reason = reason;
      this.dialogRef.close(reason);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }

}
